import { DistanceIcon } from './distanceIcon';
import { SizeIcon } from './sizeIcon';
import { WindIcon } from './windIcon';
import { CloseIcon } from './closeIcon';
import { ZoomInIcon } from './zoomInIcon';
import { ZoomOutIcon } from './zoomOutIcon';
import { ZoomToRegionIcon } from './zoomToRegionIcon';

export const Icons = {
    DistanceIcon,
    SizeIcon,
    WindIcon,
    CloseIcon,
    ZoomInIcon,
    ZoomOutIcon,
    ZoomToRegionIcon
};